import AppRoutes from "./component/AppRoutes";

function App() {
  return (
    <div className="app">
      <AppRoutes />
    </div>
  );
}

export default App;
